import { Environment } from '@portal-core/environment/environment.model';
import { environment as coreEnvironment } from '@portal-core/environment/environment';

declare const window: any;

export const environment: Environment = {
  ...coreEnvironment,
  ...window.mcEnvironment
};
